import styled from "styled-components";
import classNames from "classnames";
import media from "./media-queries";

const Wrapper = styled.div`
  background: ${(props) =>
    props.colour === "primary"
      ? props.theme.colours.primary
      : props.colour === "secondary"
      ? props.theme.colours.secondary
      : props.colour === "white"
      ? props.theme.colours.white
      : ""};
  color: ${(props) =>
    props.colour === "primary"
      ? props.theme.colours.white
      : props.colour === "secondary"
      ? props.theme.colours.white
      : props.theme.colours.darkGrey};
`;

const Container = styled.div`
  padding: 25px ${(props) => props.theme.layout.gutter.sm};

  ${media.md} {
    padding: ${(props) => props.theme.layout.gutter.md};
  }

  ${media.lg} {
    padding: ${(props) => props.theme.layout.gutter.lg};
  }
`;

const HeroCaptionText = styled.p`
  font-family: ${(props) => props.theme.typography.body.font};
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.5;
  margin: 0;
  ${media.lg} {
    font-size: 1.4rem;
  }
`;

export const Strapline = (props) => {
  const classes = classNames(`wrapper`, props.className);

  return (
    <Wrapper className={classes} colour={props.colour}>
      <Container className="container">
        <HeroCaptionText>{props.title}</HeroCaptionText>
      </Container>
    </Wrapper>
  );
};
